(function () {
  const backBtn = document.querySelector('#btns__back');

  const diamondremoveBtn = document.querySelector('#step_sub-info_diamond_removeBtn');

  const ringremoveBtn = document.querySelector('#step_sub-info_ring_removeBtn');
  const fullRingremoveBtn = document.querySelector('#step_sub-info_fullRing_removeBtn');
  
  /* Show the thankyou text when setting step is completed */
  const firstStep= document.querySelectorAll('.diamond-steps__steps__step')[0];
  const IsFirstElementSelected = document.querySelector('.diamond-steps__steps').getAttribute("data-first");
  /* check if the first step is selected and we are only on second step not further */
  if(firstStep.classList.contains("diamond-steps__steps__step--checked") && IsFirstElementSelected == "true"){
    var textArea = document.querySelector(".homepage-indiv-section-wrapper .featured-row__subtext p");
    if(textArea){
      textArea.innerText = 'Thank you for choosing the perfect setting for your ring. We are delighted to assist you in the next step of your journey towards creating a perfect piece of jewellery. With this important step completed, you are now ready to move forward and select the ideal diamond to complement your chosen setting. Our wide selection of high-quality diamonds is available to suit every preference and style. Complete your beautiful piece of jewellery by choosing a Diamond here.'
    }
  }

  async function removeDiamond(e) {
    toggleLoader();
    await fetch('/cart.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;',
      },
      body: JSON.stringify({
        attributes: {
          diamond: '',
        },
      }),
    });
    window.location = e.target.dataset.redirectUrl;
    toggleLoader();
  }

  async function removeRing(e) {
    toggleLoader();
    await fetch('/cart.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;',
      },
      body: JSON.stringify({
        attributes: {
          ring: '',
        },
      }),
    });
    window.location = e.target.dataset.redirectUrl;
    toggleLoader();
  }

  async function removeFullRing() {
    toggleLoader();
    await fetch('/cart.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;',
      },
      body: JSON.stringify({
        attributes: {
          ring: '',
          diamond: '',
        },
      }),
    });
    location.reload();
    toggleLoader();
  }

  backBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    history.back();
  });

  diamondremoveBtn?.addEventListener('click', removeDiamond);
  ringremoveBtn?.addEventListener('click', removeRing);
  fullRingremoveBtn?.addEventListener('click', removeFullRing);
})();
